import { useState, useEffect } from 'react';

export default function Reviews() {
  const [currentReview, setCurrentReview] = useState(0);

  const reviews = [
    {
      name: 'Coline Huguet',
      rating: 5,
      text: "Après une mauvaise expérience ailleurs, BR Clean m'a complètement réconciliée avec le nettoyage automobile. Travail soigné, professionnel et sérieux ! Je lui ferai confiance les yeux fermés.",
      date: 'il y a 3 mois'
    },
    {
      name: 'LEA PIRES',
      rating: 5,
      text: "Nous avons fait appel à BR Clean Auto à notre retour de vacances. Le travail est irréprochable! Très professionnel et à l'écoute. Je recommande vivement !",
      date: 'il y a 2 mois'
    },
    {
      name: 'Cedric Voissier',
      rating: 5,
      text: 'Monsieur très ponctuel et très respectueux travail très professionnel pour les 2 phares boulot super',
      date: 'il y a 2 mois'
    },
    {
      name: 'pierre thibault',
      rating: 5,
      text: "Personne très sérieuse, mon véhicule était une déchetterie. Il me l'a rendu comme quand je l'ai acheté. Travaille très professionnel et arrive avec 20 minutes d'avance sur le rendez-vous.",
      date: 'il y a un an'
    },
    {
      name: 'Juliette Aubert',
      rating: 5,
      text: "Je lui ai confié mon véhicule il me l'a rendu super propre boulot très miticuleux personne très compétente bravo à recommander",
      date: 'il y a 2 ans'
    },
    {
      name: 'AGENCE CLERMONT-FERRAND-SUD',
      rating: 5,
      text: "Je recommande à 100%, plusieurs véhicules nettoyés, travail très sérieux et professionnel.",
      date: 'il y a un an'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [reviews.length]);

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section id="avis" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Vos Avis
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Découvrez ce que nos clients disent de nos services
          </p>
          
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#FBBF24] text-2xl"></i>
              ))}
            </div>
            <span className="text-3xl font-bold text-gray-900">5.0</span>
            <span className="text-gray-600">sur Google</span>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="absolute top-8 left-8 text-[#0EA5E9] opacity-20">
              <i className="ri-double-quotes-l text-6xl"></i>
            </div>

            <div className="relative z-10">
              <div className="flex items-center gap-1 mb-6 justify-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FBBF24] text-xl"></i>
                ))}
              </div>

              <p className="text-lg text-gray-700 mb-8 text-center leading-relaxed min-h-[120px] flex items-center justify-center">
                {reviews[currentReview].text}
              </p>

              <div className="text-center">
                <p className="font-bold text-gray-900 text-lg mb-1">
                  {reviews[currentReview].name}
                </p>
                <p className="text-sm text-gray-500">
                  {reviews[currentReview].date}
                </p>
              </div>
            </div>

            <button
              onClick={prevReview}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>

            <button
              onClick={nextReview}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentReview(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentReview ? 'bg-[#0EA5E9] w-8' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://share.google/iAV2dZ92niuF7HeAr"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-[#0EA5E9] text-white rounded-lg font-semibold hover:bg-[#0284C7] transition-all whitespace-nowrap"
            >
              Laissez un Avis
            </a>
            <a
              href="https://share.google/iAV2dZ92niuF7HeAr"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white text-[#0EA5E9] border-2 border-[#0EA5E9] rounded-lg font-semibold hover:bg-[#0EA5E9] hover:text-white transition-all whitespace-nowrap"
            >
              Voir Tous les Avis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}